module.exports = __webpack_public_path__ + "img/HaaLogo.978962c3.png";